import { render, staticRenderFns } from "./MdWave.vue?vue&type=template&id=61430c9e"
import script from "./MdWave.vue?vue&type=script&lang=js"
export * from "./MdWave.vue?vue&type=script&lang=js"
import style0 from "./MdWave.vue?vue&type=style&index=0&id=61430c9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports